import { render, staticRenderFns } from "./VMark.vue?vue&type=template&id=52447365&"
import script from "./VMark.vue?vue&type=script&lang=js&"
export * from "./VMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports